"use client";

import { useEffect } from "react";
import { initAnalyticsFlush } from "@/lib/utils/analytics";

/**
 * Client component to initialize analytics event flushing.
 * Sets up beforeunload and visibilitychange handlers to ensure
 * events are sent even during page unload.
 */
export function AnalyticsFlush() {
  useEffect(() => {
    initAnalyticsFlush();
  }, []);

  return null;
}

